var React = require('react');

function CustomRulesIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"m14.65 15.31-1.887-1.888-6.267 7.66a2.542 2.542 0 1 1-3.577-3.578l7.659-6.267L8.69 9.35a1.405 1.405 0 0 1-1.986-1.986l4.966-4.966a1.405 1.405 0 0 1 1.986 1.986l5.96 5.96a1.405 1.405 0 0 1 1.986 1.986l-4.966 4.966a1.404 1.404 0 1 1-1.986-1.986zm5.42-7.321a3.391 3.391 0 0 1 2.937 5.746L18.04 18.7a3.391 3.391 0 0 1-5.7-1.626L8.034 22.34a4.529 4.529 0 1 1-6.373-6.373l5.264-4.306A3.391 3.391 0 0 1 5.3 5.96L10.264.992a3.391 3.391 0 0 1 5.746 2.937l4.059 4.059z"}));
}

CustomRulesIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CustomRulesIcon;

CustomRulesIcon.default = CustomRulesIcon;
